<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;" dense>
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Monitoramento</v-toolbar-title>

                    <v-select
                        v-if="abas.length"
                        :value="hostAtual"
                        :items="opcoesServidores"
                        item-value="value"
                        item-text="text"
                        dense
                        outlined
                        hide-details
                        class="seletor ml-3"
                        prepend-inner-icon="mdi-server"
                        @change="irPara"
                    >
                        <template v-slot:item="{ item }">
                            <v-icon v-if="item.situacao" x-small :color="corDaSituacao(item.situacao)" class="mr-2">
                                mdi-circle
                            </v-icon>
                            <v-icon v-else x-small class="mr-2">mdi-view-grid-outline</v-icon>
                            {{ item.text }}
                        </template>
                    </v-select>

                    <v-spacer/>

                    <v-tabs
                        v-if="abas.length"
                        v-model="aba"
                        right
                        show-arrows
                        class="abas"
                    >
                        <v-tab v-for="item in abas" :key="item.chave">
                            <v-icon left small>{{ item.icone }}</v-icon>
                            <span v-show="$vuetify.breakpoint.smAndUp">{{ item.titulo }}</span>
                        </v-tab>
                    </v-tabs>
                </v-toolbar>

                <div v-if="!abas.length" class="pa-12 text-center grey--text">
                    <v-icon large color="grey">mdi-lock-outline</v-icon>
                    <div class="mt-2">Seu usuário não tem permissão para ver o monitoramento.</div>
                    <div class="text-caption">
                        Peça a um diretor para liberar em Usuários → Permissões.
                    </div>
                </div>

                <v-tabs-items v-else v-model="aba" touchless class="transparente">
                    <v-tab-item v-for="item in abas" :key="item.chave">
                        <template v-if="item.chave === 'visao-geral'">
                            <PainelFrota
                                v-if="!hostAtual"
                                :servidores="servidores"
                                :totais="totais"
                                :loading="loading"
                                @abrir="irPara"
                                @recarregar="carregarResumo"
                            />
                            <TabVisaoGeral
                                v-else
                                :key="hostAtual"
                                :host="hostAtual"
                                @voltar="irPara(null)"
                            />
                        </template>

                        <TabAlertas v-else-if="item.chave === 'alertas'" :host="hostAtual"/>
                        <TabRegras v-else/>
                    </v-tab-item>
                </v-tabs-items>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import PainelFrota from './PainelFrota';
import TabVisaoGeral from './TabVisaoGeral';
import TabAlertas from './TabAlertas';
import TabRegras from './TabRegras';
import { carregarCatalogo } from './catalogo';
import { carregarServidores, corDaSituacao } from './servidores';

export default {
    name: 'Monitoramento',

    components: {
        BaseContainer,
        PainelFrota,
        TabVisaoGeral,
        TabAlertas,
        TabRegras,
    },

    data: () => ({
        aba: 0,
        loading: false,
        servidores: [],
        totais: { servidores: 0, com_alerta: 0, sem_coleta: 0 },
        timer: null,
    }),

    mounted() {
        if (!this.abas.length) return;

        this.carregarResumo();

        this.timer = setInterval(() => this.carregarResumo(), 60000);
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },

    computed: {
        abas() {
            const lista = [];

            // Espelha o que o servidor faz: as rotas conferem a mesma permissão,
            // e o PermissaoMiddleware deixa DIRETOR passar direto.
            if (this.checkPermission('zapercontrol_monitoramento_consultar') || this.isDiretor()) {
                lista.push({ chave: 'visao-geral', titulo: 'Visão geral', icone: 'mdi-view-dashboard-outline' });
                lista.push({ chave: 'alertas', titulo: 'Alertas', icone: 'mdi-bell-outline' });
                lista.push({ chave: 'regras', titulo: 'Regras', icone: 'mdi-tune' });
            }

            return lista;
        },

        hostAtual() {
            return this.$route.params.host || null;
        },

        opcoesServidores() {
            return [
                { value: null, text: 'Todos os servidores', situacao: null },
                ...this.servidores.map(s => ({
                    value: s.host,
                    text: s.nome,
                    situacao: s.situacao,
                })),
            ];
        },
    },

    methods: {
        corDaSituacao,

        irPara(host) {
            if ((this.$route.params.host || null) === (host || null)) return;

            this.$router.push(host ? `/monitoramento/${host}` : '/monitoramento');
        },

        async carregarResumo() {
            this.loading = true;
            try {
                await carregarCatalogo(this.$http);
                await carregarServidores(this.$http);

                const { data } = await this.$http.get('monitoramento/resumo');

                this.servidores = data.servidores || [];
                this.totais = data.totais || this.totais;

                this.conferirHostDaUrl();
            } catch (e) {
                this.notify('Não foi possível carregar os servidores', 'error');
            }
            this.loading = false;
        },

        conferirHostDaUrl() {
            if (!this.hostAtual) return;

            if (!this.servidores.some(s => s.host === this.hostAtual)) {
                this.notify(`O servidor "${this.hostAtual}" não está mais ativo no registro`, 'warning');
                this.irPara(null);
            }
        },
    },
};
</script>

<style scoped>
.abas {
    max-width: 420px;
}

.seletor {
    max-width: 260px;
}

.transparente >>> .v-window__container {
    background: transparent;
}
</style>
